module.exports = "https://static-www.niulinkcloud.com/_next/static/media/mobileBanner1.304873a782c0144d258f19d7593be3e9.png";